import styled from 'styled-components';
import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`

	.body--interactive {
		overflow-y:scroll;
	}



	//Styles to remove:

	html {
		box-sizing:border-box;
		font-size: 62.5%;
		@media(max-width:1660px){
		  font-size: 55%;
		}
		@media(max-width:1200px) {
		  font-size: 50%;
		}
		@media(max-width:1000px) {
		  font-size: 48%;
		}
		@media(max-width:768px) {
		  font-size: 50%;
		}
		@media(max-width:550px) {
		  font-size: 45%;
		}
	}

	body {
		font-family:'GTAmerica Standard', sans-serif;
	}

	h1, h2, h3, h4, h5 {
		font-family:'GTAmerica Extended', sans-serif;
	}
    
	*, *:before, *:after{
		box-sizing:inherit;
	}

	@keyframes pinDrop {
		0%   { opacity: 0; transform:scale(0)}
		100% { opacity: 1; transform:scale(1)}
	}

	@keyframes pinDropMobile {
		0%   { opacity: 0;}
		100% { opacity: 1;}
	}

	// @keyframes mapAppear {
	// 	0%   { opacity: 0; }
	// 	100% { opacity: 1; }
	// }

	// @keyframes sidenavOut {

	// }

	// @keyframes mobileUXFade {
	// 	0% { opacity: 1;}
	// 	100% { opacity: 0; }
	// }
`;

export default GlobalStyles;